import React, { Component } from 'react'
//import demo from "../akshay.jpg"
import axios from "axios";
import AdminNavFormProfile from './AdminNavFormProfile';
import { Link } from "react-router-dom";
import Path from "./config";
import Moment from 'moment';
//import BtnFiveHundread from './BtnFiveHundread';

export class FullbiodataAdminedit extends Component {
    constructor(props) {
        super(props);
        //for radiodisabled onchange
        //this.showScanType = this.showScanType.bind(this);

        this.state = {

            sbg_first_name: '',
            sbg_middle_name: '',
            sbg_last_name: '',
            sbg_mulgav: '',
            sbg_sex: '',
            sbg_bloodgroup_id: '',
            sbg_birth_name: '',
            sbg_birth_place: '',
            sbg_birth_date: '',
            sbg_birth_time: '',
            sbg_skin_complexion_id: '',
            sbg_zodiac_signs_id: '',
            sbg_height_id: '',
            sbg_gotra_id: '',
            sbg_mama_kul: '',
            sbg_mama_place: '',
            sbg_marital_status_id: '',
            sbg_handicapped: '',
            sbg_mangal_status_id: '',
            sbg_birth_year: '',
            sbg_birth_month: '',
            userId: null,
            sbg_unmarried_brother: "",
            sbg_married_brother: "",
            sbg_unmarried_sister: "",
            sbg_married_sister: "",
            sbg_mother_full_name: "",
            sbg_father_full_name: "",
            sbg_other_mobile_no1: "",
            sbg_other_mobile_no2: "",
            sbg_parents_address: "",
            sbg_parent_job_buisness: "",
            sbg_education_id: '',
            sbg_other_education: '',
            education: [],
            sbg_job_business_info: "",
            sbg_company_name_address: "",
            sbg_yearly_income: "",
            sbg_expectation: "",
            sbg_post_full_name: "",
            sbg_post_mobileno: "",
            sbg_post_pincode: "",
            sbg_post_state: "",
            sbg_post_district: "",
            sbg_post_taluka: "",
            sbg_post_place: "",
            sbg_post_full_address: "",

            sbgr_person_name: "",
            sbgr_bride_groom_relation: "",
            sbgr_Mobile_no1: "",
            sbgr_Mobile_no2: "",
            sbgr_address: "",
            sbg_list: [],
            sbg_edu_specialization: '',
            sbg_photo: '',
            sbg_status_button: true,
            aaptyaDiv: false,
            ghatspotDiv: false,
            vidhvaDateDiv: false,
            VibhktaDateDiv: false,
            vivahDateDiv: false,
            sbg_status_app: false,
            sbg_gh_marriage_date: "",
            sbg_gh_vibhakta_date: "",
            sbg_gh_divorce_date: "",
            sbg_aptya_girl_no: "",
            sbg_aptya_girl_age: "",
            sbg_aptya_boy_no: "",
            sbg_aptya_boy_age: "",
            sbg_vidhva_date: "",
            sbg_lpid: '',
            showPaymentBtn: false,
            admin: '',
            adminid: '',
            btn_sen_to_approved: false
        }
    }
    componentDidMount() {
        this.setState({
            userId: localStorage.getItem("userId")
        })
        localStorage.setItem("userId", this.props.match.params.sbg_id);

        axios.get(Path + 'Show_bride_groom_summery.php?sbg_id=' + this.props.match.params.sbg_id)
            .then(function (response) {
                // handle success
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                //   data=response.data;
                response = response.data;
                let sbg_photo = Path + response.sbg_photo;

                if (response.sbg_office_appoved_status !== "0") {
                    this.setState({
                        sbg_status_button: true,
                        sbg_status_app: false,
                        btn_sen_to_approved: true
                    })

                }
                if (response.sbg_marital_status === "1") {
                    this.setState({
                        aaptyaDiv: false,
                        ghatspotDiv: false,
                        vidhvaDateDiv: false,
                        VibhktaDateDiv: false,
                        vivahDateDiv: false,
                    })
                }
                else if (response.sbg_marital_status === "2") {
                    this.setState({
                        aaptyaDiv: true,
                        ghatspotDiv: true,
                        vidhvaDateDiv: false,
                        VibhktaDateDiv: true,
                        vivahDateDiv: true,
                    })
                }
                else if (response.sbg_marital_status === "3") {
                    this.setState({
                        aaptyaDiv: true,
                        ghatspotDiv: false,
                        vidhvaDateDiv: true,
                        VibhktaDateDiv: false,
                        vivahDateDiv: true,
                    })
                }
                else if (response.sbg_marital_status === "4") {
                    this.setState({
                        aaptyaDiv: true,
                        ghatspotDiv: false,
                        vidhvaDateDiv: false,
                        VibhktaDateDiv: false,
                        vivahDateDiv: true,
                    })
                }
                else if (response.sbg_marital_status === "5") {
                    this.setState({
                        aaptyaDiv: false,
                        ghatspotDiv: true,
                        vidhvaDateDiv: false,
                        VibhktaDateDiv: true,
                        vivahDateDiv: true,
                    })
                }
                // let today = response.sbg_birth_date;
                let date = Moment(response.sbg_birth_date).format('DD-MM-YYYY');

                if (response.sbg_lpid_status === "1") {
                    this.setState({
                        enterId: false,
                        showInfo: true,
                    })
                }
                if (response.sbg_payment_amount === "100") {
                    this.setState({

                        showPaymentBtn: true,
                    })
                }
                else {
                    this.setState({

                        showPaymentBtn: false,
                    })
                }


                this.setState({

                    sbg_first_name: response.sbg_first_name,
                    sbg_middle_name: response.sbg_middle_name,
                    sbg_last_name: response.sbg_last_name,
                    sbg_mulgav: response.sbg_mulgav,
                    sbg_sex: response.sbg_sex,
                    sbg_bloodgroup_id: response.sbg_bloodgroup_id,
                    sbg_birth_name: response.sbg_birth_name,
                    sbg_birth_place: response.sbg_birth_place,

                    sbg_birth_date: date,
                    sbg_birth_time: response.sbg_birth_time,

                    sbg_skin_complexion_id: response.sbg_skin_complexion_id,
                    sbg_zodiac_signs_id: response.sbg_zodiac_signs_id,
                    sbg_height_id: response.sbg_height_id,
                    sbg_gotra_id: response.sbg_gotra_id,
                    sbg_mama_kul: response.sbg_mama_kul,
                    sbg_mama_place: response.sbg_mama_place,
                    sbg_marital_status_id: response.sbg_marital_status_id,
                    sbg_handicapped: response.sbg_handicapped,
                    sbg_mangal_status_id: response.sbg_mangal_status_id,

                    sbg_property_detail: response.sbg_property_detail,

                    sbg_education_id: response.sbg_education_id,

                    sbg_other_education: response.sbg_other_education,

                    sbg_photo: sbg_photo,
                    sbg_unmarried_brother: response.sbg_unmarried_brother,
                    sbg_married_brother: response.sbg_married_brother,
                    sbg_unmarried_sister: response.sbg_unmarried_sister,
                    sbg_married_sister: response.sbg_married_sister,
                    sbg_mother_prifix: response.sbg_mother_prifix,
                    sbg_father_prifix: response.sbg_father_prifix,

                    sbg_mother_full_name: response.sbg_mother_full_name,
                    sbg_father_full_name: response.sbg_father_full_name,
                    sbg_other_mobile_no1: response.sbg_other_mobile_no1,
                    sbg_other_mobile_no2: response.sbg_other_mobile_no2,
                    sbg_parents_address: response.sbg_parents_address,
                    sbg_parent_job_buisness: response.sbg_parent_job_buisness,

                    sbg_job_business_info: response.sbg_job_business_info,
                    sbg_company_name_address: response.sbg_company_name_address,
                    sbg_yearly_income: response.sbg_yearly_income,
                    sbg_expectation: response.sbg_expectation,
                    sbg_post_full_name: response.sbg_post_full_name,
                    sbg_post_mobileno: response.sbg_post_mobileno,
                    sbg_post_pincode: response.sbg_post_pincode,
                    sbg_post_state: response.sbg_post_state,
                    sbg_post_district: response.sbg_post_district,
                    sbg_post_taluka: response.sbg_post_taluka,
                    sbg_post_place: response.sbg_post_place,
                    sbg_post_full_address: response.sbg_post_full_address,
                    sbg_edu_specialization: response.sbg_edu_specialization,

                    sbg_gh_marriage_date: response.sbg_gh_marriage_date,
                    sbg_gh_vibhakta_date: response.sbg_gh_vibhakta_date,
                    sbg_gh_divorce_date: response.sbg_gh_divorce_date,
                    sbg_aptya_girl_no: response.sbg_aptya_girl_no,
                    sbg_aptya_girl_age: response.sbg_aptya_girl_age,
                    sbg_aptya_boy_no: response.sbg_aptya_boy_no,
                    sbg_aptya_boy_age: response.sbg_aptya_boy_age,
                    sbg_vidhva_date: response.sbg_vidhva_date,
                    sbg_lpid_status: response.sbg_lpid_status,
                    sbg_payment_amount: response.sbg_payment_amount
                })
            }.bind(this))


        axios.get(Path + 'Suchi_bride_groom_relatives_view.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                // handle success
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                this.setState({ sbg_list: response.data.relatives_list })
            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });

    }

    lpidHandler = (e) => {

        this.setState
            ({ sbg_lpid_status: e.target.value }, () => {

                if (this.state.sbg_lpid_status === "yes") {
                    this.setState({
                        enterId: true,
                        showInfo: false
                    })
                }
                else {
                    this.setState({
                        enterId: false,
                        showInfo: true
                    })
                }
            })
    }

    valHandler = (e) => {

        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_lpid: e.target.value })
        }
    }

    submitLpid = () => {
        let typee = "lpid";

        let tempStr = "sbg_lpid=" + this.state.sbg_lpid +
            "&sbg_id=" + localStorage.getItem("userId") +
            "&type=" + typee

        // console.log("wwwwwwwwwwwwwwwwwwwwwwww",tempStr)
        axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
            .then(function (response) {
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                if (response.data.status === "updated") {
                    alert("LP ID Updated....")
                    // this.props.history.push(`/FormProfile/`);

                } else {

                }

            })

    }
    changeFormStatus = (e) => {
        //e.preventDefault();
        // let typee="asset";

        alert("ho");
        let r = window.confirm(" प्रोफाईल फायनल सबमिशन साठी पाठवायची आहे ");
        if (r === true) {
            let tempStr = "&sbg_id=" + this.state.userId

            axios.post(Path + `Suchi_bride_groom_change_status_user.php?` + tempStr)
                .then(function (response) {
                    if (response.data.result === "Updated") {
                        this.setState({
                            btn_sen_to_approved: true
                        })

                        localStorage.removeItem('userId');
                        //localStorage.removeItem('phoneId');
                        // window.location.reload(false);
                        this.props.history.push(`/AdminProfile/ShowSuchiList`);
                    }
                }
                    .bind(this))
        }
    }





    render() {
        //console.log(this.state.sbg_status_button);
        let renderTableData =
            this.state.sbg_list.map((slist, index) => {
                const { sbgr_id, sbgr_prifix, sbgr_person_name, sbgr_bride_groom_relation, sbgr_Mobile_no1, sbgr_Mobile_no2, sbgr_address } = slist //destructuring
                return (
                    <tr key={sbgr_id}>

                        <td>{sbgr_prifix}. {sbgr_person_name}</td>
                        <td>{sbgr_bride_groom_relation}</td>
                        <td>{sbgr_Mobile_no1}</td>
                        <td>{sbgr_Mobile_no2}</td>
                        <td>{sbgr_address}</td>
                        <td>
                        </td>
                    </tr>
                )
            })
        return (
            <>
                {this.state.sbg_status_button ?
                    <AdminNavFormProfile /> : null}
                <div className=" m-5 border border-secondary bg-white p-5 lh-base">
                    <div className="row g-3  ">
                        <div className="col-md-8 bg-warning p-3">
                            <b>  तुमची लेवा शुभमंगल मोबाईल सूचित नाव नोंदणी आहे का ? </b>&nbsp;&nbsp;
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="sbg_lpid_status" value="yes" checked={this.state.sbg_sex === 'yes'} onChange={this.lpidHandler} id="inlineRadio1" />
                                <label className="form-check-label" htmlFor="inlineRadio1">होय  </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="sbg_lpid_status" value="no" checked={this.state.sbg_sex === 'no'} onChange={this.lpidHandler} id="inlineRadio2" />
                                <label className="form-check-label" htmlFor="inlineRadio2">नाही</label>
                            </div>
                        </div>
                        {/* {this.state.showPaymentBtn?
                    <div div className="col-md-4 text-lg-center ">
                     <span className="blinking" >सूची ची फी भरण्यासाठी खालील बटणावर क्लिक करावे.</span> 
                        <BtnFiveHundread/>
                    </div>
                    :null} */}
                    </div>

                    {this.state.enterId ?
                        <div className="row g-3  ">
                            <div className="col-md-8 bg-warning p-3">
                                <label htmlFor="formGroupExampleInput2" className="form-label">  LP ID टाकावा</label><br></br>
                                LP - <input type="text" className="txt_box" value={this.state.sbg_lpid} onChange={this.valHandler} style={{ width: "120px" }} />
                                <button className="btn-success btn" onClick={() => this.submitLpid()}>OK</button>
                            </div>
                        </div>
                        : null}
                    {this.state.showInfo ?
                        <div className="row g-3  ">
                            <div className="col-md-8 bg-warning p-3">

                                <a href="https://play.google.com/store/apps/details?id=com.flyctsofttech.matrimonialapp" target="_blank" rel="noreferrer">
                                    https://play.google.com/store/apps/details?id=com.flyctsofttech.matrimonialapp</a>
                                <br></br>
                                या लिंक वर क्लिक करिन आताच अँप डाऊनलोड करून आपली विवाह नोंदणी पूर्ण करून घ्यावी.
                                आपण जर पुस्तक सुची नोंदणी केल्यापासून पुढील 5 दिवसात मोबाईल अँप सूचित नोंदणी केल्यास
                                आपल्याला तेथील 100/- नोंदणी शुल्क भरायची आवश्यकता नाही.
                            </div>
                        </div>
                        : null}
                    <div className="row g-3 ">
                        <div className="row text-primary mb-5">
                            <div className="col-md-8"><br /><br />
                                टीप :- <br />
                                कृपया आपली संपूर्ण माहिती पुन्हा एकदा चेक करावी ,
                                बदल करायचे असल्यास आताच करून घ्यावे ,
                                सर्व माहिती बरोबर असेल तर SUBMIT FOR APPROVAL  वर क्लिक करावे .
                            </div>
                            <div className="col-md-4  text-lg-right">
                                <br /><br />
                                {this.state.btn_sen_to_approved ?
                                    <button type="button" className="btn btn-danger" >Profile Completed</button>
                                    :
                                    <button type="button" className="btn btn-danger" onClick={() => this.changeFormStatus()}>SUBMIT FOR APPROVAL</button>}


                            </div>
                        </div>


                        {this.state.sbg_status_app ?
                            <div className="row text-success mb-5">
                                <div className="col-md-12">
                                    <h4>   तुमची प्रोफाईल आमच्या अडमीन कडे approval साठी यशस्वीरित्या पाठविण्यात आलेली आहे</h4>
                                </div>

                            </div>
                            : null}

                        <div className="row">
                            <div className="col-md-8 d-flex justify-content-center text-primary font-weight-bold">
                                <h4 className="px-3 mx-auto" >वैयक्तिक माहिती </h4>
                            </div>
                            {this.state.sbg_status_button ? <div className="col-md-4 d-flex text-xl-right">
                                <Link to={`/AdminProfile/PersonalInfo`} className="text-warning font-weight-bold">
                                    <button type="button" className="btn btn-warning">EDIT</button> </Link>
                            </div> : null}
                        </div>
                        <div className="col-md-8">

                            <div className="row">
                                <div className="col-md-3">वधू वराचे नाव </div>
                                <div className="col-md-1"> : </div>
                                <div className="col-md-6">{this.state.sbg_first_name + " " + this.state.sbg_middle_name + " " + this.state.sbg_last_name} </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3"> मुळगाव  </div>
                                <div className="col-md-1">  :  </div>
                                <div className="col-md-6">  {this.state.sbg_mulgav}   </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">लिंग</div>
                                <div className="col-md-1">: </div>
                                <div className="col-md-6">{this.state.sbg_sex}  </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    रक्त गट
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_bloodgroup_id}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    जन्म नाव
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_birth_name}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    जन्म ठिकाण
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_birth_place}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    जन्म दिनांक
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_birth_date}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    जन्म वेळ
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">{this.state.sbg_birth_time}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    रंग
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_skin_complexion_id}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    जन्म राशी
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_zodiac_signs_id}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    उंची
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_height_id}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    गोत्र
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_gotra_id}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    मामकुळ
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_mama_kul}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    मामाचे गाव
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_mama_place}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3"> वैवाहिक स्थिती  </div>
                                <div className="col-md-1"> : </div>
                                <div className="col-md-6">{this.state.sbg_marital_status_id}</div>
                            </div>
                            {this.state.aaptyaDiv ? <div className="row">

                                <div className="col-md-3"> अपत्य</div>
                                <div className="col-md-1"> : </div>
                                <div className="col-md-6">
                                    <table className="bg-white table" >
                                        <tbody>
                                            <tr >
                                                <td className="bg-gray ">अपत्य</td>
                                                <td className="">संख्या</td>
                                                <td className="">वय</td>
                                            </tr>
                                            <tr>
                                                <td className="bg-gray">मुलगा</td>
                                                <td>{this.state.sbg_aptya_boy_no}</td>
                                                <td>{this.state.sbg_aptya_boy_age} </td>
                                            </tr>
                                            <tr>
                                                <td className="bg-gray"> मुलगी</td>
                                                <td>{this.state.sbg_aptya_girl_no}</td>
                                                <td>{this.state.sbg_aptya_girl_age} </td>
                                            </tr>
                                        </tbody>
                                    </table></div>
                            </div>

                                : null}

                            {this.state.vivahDateDiv ? <div className="row">
                                <div className="col-md-3"> विवाह तारीख </div>
                                <div className="col-md-1"> : </div>
                                <div className="col-md-6">{this.state.sbg_gh_marriage_date}</div>
                            </div>
                                : null}

                            {this.state.VibhktaDateDiv ? <div className="row">
                                <div className="col-md-3"> विभक्त होण्याची तारीख </div>
                                <div className="col-md-1"> : </div>
                                <div className="col-md-6">{this.state.sbg_gh_vibhakta_date}</div>
                            </div>
                                : null}

                            {this.state.ghatspotDiv ? <div className="row">
                                <div className="col-md-3"> घटस्फोटाची तारीख  </div>
                                <div className="col-md-1"> : </div>
                                <div className="col-md-6">{this.state.sbg_gh_divorce_date}</div>
                            </div>
                                : null}

                            {this.state.vidhvaDateDiv ? <div className="row">
                                <div className="col-md-3"> विधवा / विधुर होण्याची   तारीख  </div>
                                <div className="col-md-1"> : </div>
                                <div className="col-md-6">{this.state.sbg_vidhva_date}</div>
                            </div>
                                : null}









                            <div className="row">
                                <div className="col-md-3">
                                    अपंगत्व / शाररिक दोष
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_handicapped}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    मंगळ दोष
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_mangal_status_id}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    अपेक्षा
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_expectation}
                                </div>
                            </div>


                        </div>
                        <div className="col-md-4">
                            <img src={this.state.sbg_photo} alt="test" className="img-fluid"></img>
                        </div>
                    </div>

                    <div className="row g-3 mt-3">
                        <div className="row m-2">
                            <div className="col-md-8 d-flex justify-content-center text-primary font-weight-bold">
                                <h4 className="px-3 mx-auto" >शैक्षणिक माहिती  </h4>
                            </div>
                            {this.state.sbg_status_button ? <div className="col-md-4 d-flex text-xl-right">
                                <Link to={`/AdminProfile/EducationInfo`} className="text-warning font-weight-bold">
                                    <button type="button" className="btn btn-warning">EDIT</button> </Link>
                            </div> : null}
                        </div>
                        <div className="col-md-8">

                            <div className="row">
                                <div className="col-md-3">
                                    शिक्षणाची कॅटेगिरी
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_education_id}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    शिक्षण
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_edu_specialization}
                                </div>
                            </div>


                        </div>

                    </div>

                    <div className="row g-3 mt-3">
                        <div className="row m-3">
                            <div className="col-md-8 d-flex justify-content-center text-primary font-weight-bold">
                                <h4 className="px-3 mx-auto" >उत्पन्न विषयी माहिती  </h4>
                            </div>
                            {this.state.sbg_status_button ? <div className="col-md-4 d-flex text-xl-right">
                                <Link to={`/AdminProfile/IncomeInfo`} className="text-warning font-weight-bold">
                                    <button type="button" className="btn btn-warning">EDIT</button> </Link>
                            </div> : null}
                        </div>
                        <div className="col-md-8">

                            <div className="row">
                                <div className="col-md-3">
                                    कंपनी चे नाव
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_job_business_info}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    पत्ता
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_company_name_address}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    वार्षिक उत्पन्न
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_yearly_income}
                                </div>
                            </div>


                        </div>

                    </div>
                    <div className="row g-3 mt-3">
                        <div className="row m-3">
                            <div className="col-md-8 d-flex justify-content-center text-primary font-weight-bold">
                                <h4 className="px-3 mx-auto" >कौटुंबिक माहिती</h4>
                            </div>
                            {this.state.sbg_status_button ? <div className="col-md-4 d-flex text-xl-right">
                                <Link to={`/AdminProfile/FamilyInfo`} className="text-warning font-weight-bold">
                                    <button type="button" className="btn btn-warning">EDIT</button> </Link>
                            </div> : null}
                        </div>
                        <div className="col-md-8">


                            <div className="row">
                                <div className="col-md-3">
                                    अविवाहित भाऊ
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_unmarried_brother}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    विवाहित भाऊ
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_married_brother}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    अविवाहित बहीण
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_unmarried_sister}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    विवाहित बहीण
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_married_sister}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-3">
                                    आईचे पूर्ण नाव
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_mother_prifix}. {this.state.sbg_mother_full_name}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    वडिलांचे पूर्ण नाव
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_father_prifix}. {this.state.sbg_father_full_name}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    मोबाइल नंबर 1
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_other_mobile_no1}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    मोबाइल नंबर 2
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_other_mobile_no2}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    आई वडिलांचा पत्ता
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_parents_address}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    व्यवसाय
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_parent_job_buisness}
                                </div>
                            </div>




                        </div>

                    </div>


                    <div className="row g-3 mt-3">
                        <div className="row mt-3">
                            <div className="col-md-8 mt-3 d-flex justify-content-center text-primary font-weight-bold">
                                <h4 className="px-3 mx-auto" >संपर्कासाठी ओळखीच्या प्रतिष्ठित व्यक्तींचे नावे  </h4>
                            </div>
                            {this.state.sbg_status_button ? <div className="col-md-4 d-flex text-xl-right">
                                <Link to={`/AdminProfile/ContactInfo`} className="text-warning font-weight-bold">
                                    <button type="button" className="btn btn-warning">EDIT</button> </Link>
                            </div> : null}
                        </div>
                        <div className="col-md-12">


                            <table className=" table table-hover">
                                <thead>
                                    <tr>

                                        <th scope="col">व्यक्तीचे संपूर्ण नाव</th>
                                        <th scope="col">वधू वरसोबत असलेले नाते</th>
                                        <th scope="col">मोबाइल नंबर 1</th>
                                        <th scope="col">मोबाइल नंबर 2</th>
                                        <th scope="col">पत्ता</th>

                                    </tr>
                                </thead>

                                <tbody>
                                    {renderTableData}
                                </tbody>
                            </table>





                        </div>

                    </div>


                    <div className="row g-3 mt-3">
                        <div className="row m-3">
                            <div className="col-md-8 d-flex justify-content-center text-primary font-weight-bold">
                                <h4 className="px-3 mx-auto" >स्थावर मालमत्ता  </h4>
                            </div>
                            {this.state.sbg_status_button ? <div className="col-md-4 d-flex text-xl-right">
                                <Link to={`/AdminProfile/AssetInfo`} className="text-warning font-weight-bold">
                                    <button type="button" className="btn btn-warning">EDIT</button> </Link>
                            </div> : null}
                        </div>
                        <div className="col-md-8">

                            <div className="row">
                                <div className="col-md-3">
                                    मालमत्तेचे विवरण
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_property_detail}
                                </div>
                            </div>




                        </div>

                    </div>


                    <div className="row g-3 mt-3">
                        <div className="row m-3">
                            <div className="col-md-8 d-flex justify-content-center text-primary font-weight-bold">
                                <h4 className="px-3 mx-auto" >पत्ता</h4>
                            </div>
                            {this.state.sbg_status_button ? <div className="col-md-4 d-flex text-xl-right">
                                <Link to={`/AdminProfile/PostAddress`} className="text-warning font-weight-bold">
                                    <button type="button" className="btn btn-warning">EDIT</button> </Link>
                            </div> : null}
                        </div>
                        <div className="col-md-8">

                            <div className="row">
                                <div className="col-md-3">
                                    पूर्ण नाव
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_post_full_name}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    मोबाईल क्रमांक
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_post_mobileno}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    पिन कोड
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_post_pincode}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">

                                    राज्य
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_post_state}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    जिल्हा
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_post_district}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    तालुका
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_post_taluka}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    गाव
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_post_place}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    संपूर्ण पत्ता
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_post_full_address}
                                </div>
                            </div>


                        </div>

                    </div>
                </div>

            </>
        )
    }
}

export default FullbiodataAdminedit